import { useContext, useState, useEffect } from "react";
import Button from "../../../elements/buttons/ButtonAction";
import ButtonAction from "../../../elements/buttons/ButtonAction";
import modalContext from "../../../../dataManager/context/modalContext";
import Input from "../../../elements/form/Input";
import InputFile from "../../../elements/form/InputFile";
import { checkFiels } from "../../../../functions/functions";
import { uploadImage } from "../../../../api/utils/";
import { updateAdmin } from "../../../../api/admins/adminApi";
import { toast } from "react-toastify";
import currentAdminContext from "../../../../dataManager/context/currentAdminContext";
import InputSelect from "../../../elements/form/InputSelect";

const EditAdmin = () => {
  //context variable
  const { onClose, modalParams } = useContext(modalContext);
  const { currentAdmin } = useContext(currentAdminContext);

  // init the form state
  const initFormData = {
    name: currentAdmin.getName,
    phone: currentAdmin.getPhone,
    gender: currentAdmin.getGender,
    image: currentAdmin.getImage,
  };

  //state form variables
  const [formData, setFormData] = useState(initFormData);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  //firebase state variables
  const [imageUrl, setImageUrl] = useState("");
  const [progressLoadingImage, setProgressLoadingImage] = useState(0);
  const [isLoadingImage, setIsLoadingImage] = useState(false);

  //some handlers
  const handleChange = (e, inputTarget) => {
    setError("");
    switch (inputTarget) {
      case "name":
        return setFormData({ ...formData, name: e.target.value });
      case "phone":
        return setFormData({ ...formData, phone: e.target.value });
      case "image":
        return setFormData({ ...formData, image: e.target.files[0] });
      case "gender":
        return setFormData({ ...formData, gender: Number(e.target.value) });
      default:
        return;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    console.log(formData);

    //remove the gender from data to check
    const { gender, ...dataToCheck } = formData;

    //check if the form is valid
    if (!checkFiels(dataToCheck)) {
      return setError("Veuillez remplir tous les champs");
    }

    //start loading
    setLoading(true);

    //edit category without changing the image
    if (formData.image === currentAdmin.getImage) {
      return await editAdmin(modalParams.adminId, formData);
    }

    //upload new image on firebase before update the category
    uploadImage(
      "admins",
      formData.image,
      setImageUrl,
      setProgressLoadingImage,
      setIsLoadingImage
    );
  };

  //edit the category with the new image
  useEffect(() => {
    if (imageUrl) {
      editAdmin(modalParams.adminId, {
        ...formData,
        image: imageUrl,
      });
    }
  }, [imageUrl]);

  async function editAdmin(idUser, dataUser) {
    //update the product
    const { data, error } = await updateAdmin(idUser, dataUser);

    if (error) {
      setError(error);
      return setLoading(false);
    }

    if (!data) {
      setError("Une erreur est survenue");
      return setLoading(false);
    }

    setLoading(false);
    toast.success("Vos informations ont été modifiés avec succes !", {
      theme: "colored",
    });
    onClose();
  }

  //destructuring the formData
  const { name, phone } = formData;
  return (
    <form onSubmit={handleSubmit}>
      <div className="flex flex-col space-y-2">
        <InputFile
          labelName="Photo de profile"
          name="image-user"
          onChange={(e) => handleChange(e, "image")}
        />
        <Input
          labelName="Nom de profile"
          type="text"
          name="name"
          placeholder="Votre nouveau nom"
          value={name}
          onChange={(e) => handleChange(e, "name")}
        />

        <Input
          labelName="Numéro de téléphone"
          type="number"
          name="phone"
          placeholder="Votre numéro de téléphone"
          value={phone}
          onChange={(e) => handleChange(e, "phone")}
        />

        <InputSelect
          labelName="Modifier le sexe"
          options={[
            { label: "Homme", value: 1 },
            { label: "Femme", value: 0 },
          ]}
          onChange={(e) => handleChange(e, "gender")}
        />
      </div>
      <div className="mt-4 flex items-center space-x-2">
        <Button size="small" loading={loading}>
          Modifier
        </Button>
        <ButtonAction size="small" type="secondary" onClick={onClose}>
          Anuler
        </ButtonAction>
      </div>
      <span className="font-nunito text-sm text-[#fc3838]">
        {error && error}
      </span>
    </form>
  );
};

export default EditAdmin;
